import BaseModel from './base';

class CollaboratorModel extends BaseModel {
	async list(params = {}) {
		const queryParams = new URLSearchParams();

		for (const [key, value] of Object.entries(params)) {
			if (Array.isArray(value)) {
				value.forEach(item => queryParams.append(key, item));
			} else {
				queryParams.append(key, value);
			}
		}

		return this.get(`?${queryParams}`);
	}

	async create(body) {
		return this.post('', { body });
	}

	async edit(body) {
		return this.patch('', { body });
	}

	async deleteCollaborator(id) {
		return this.delete(`/${id}`);
	}

	async sendInvitation(id) {
		return this.post(`/${id}/send-invitation`);
	}
}

export default new CollaboratorModel('/user/collaborator');
